export default class Input {
	constructor() {
		this.inputs = document.querySelectorAll(".jsInput");
		this.init();
	}

	init() {
		// let l = this.input.length;
		this.inputs.forEach(input => {
			// Run through all fields once, in case any are pre-populated
			this.updateInputState(input);
			// Watch them all for changes
			input.addEventListener("change", () => {
				this.updateInputState(input);
			});
		});
	}

	updateInputState(input) {
		input.value === ""
			? input.parentElement.classList.remove("freeze")
			: input.parentElement.classList.add("freeze");
	}
}
